import React from 'react';
import { Stack, Link, Typography } from '@mui/material';
import { toAbsoluteUrl } from '../trackingTemplateUtils';

// Footer policy links (Terms / Return Policy / Privacy). Renders only the ones the brand provides,
// separated by a middot. Single source so every template footer stays consistent.
const ITEMS = [
    { key: 'termsAndConditions', label: 'Terms & Conditions' },
    { key: 'returnPolicy', label: 'Return Policy' },
    { key: 'privacyPolicy', label: 'Privacy Policy' },
];

export default function PolicyLinks({ brand, color = '#9A9A95', size = 12 }) {
    const items = ITEMS.filter((i) => brand && brand[i.key]);
    if (!items.length) return null;
    return (
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ flexWrap: 'wrap', rowGap: 0.5 }}>
            {items.map((i, idx) => (
                <React.Fragment key={i.key}>
                    {idx > 0 && <Typography component="span" sx={{ fontSize: size, color, opacity: 0.5 }}>·</Typography>}
                    <Link href={toAbsoluteUrl(brand[i.key])} target="_blank" rel="noreferrer" underline="hover" sx={{ fontSize: size, color }}>
                        {i.label}
                    </Link>
                </React.Fragment>
            ))}
        </Stack>
    );
}
